export default __webpack_public_path__ + "static/media/EPA-1.28aad67f.jpg";